export const TEST_UPDATE = 'TEST_UPDATE';

export const testUpdate = () => ({
  type: TEST_UPDATE,
});
